import { inject, Pipe, PipeTransform } from '@angular/core';

import { ApContentService } from '@ap/content';

/**
 * @ngdoc pipe
 * @name ApAriaLabelPipe
 * @module PaginatorModule
 * @description
 * returns an aria-label formatted string
 * @param {number} ariaLabel
 *
 **/
import content from './paginator.content.json';

@Pipe({ name: 'ariaLabel' })
export class ApAriaLabelPipe implements PipeTransform {
    private readonly contentService = inject(ApContentService);

    constructor() {
        this.contentService.addContentItems(content);
    }

    transform(pageNumber: number | string): string {
        if (typeof pageNumber === 'string') {
            return `${this.contentService.get('paginator.aria.string')}${pageNumber}`;
        }
        return `${this.contentService.get('paginator.aria.numeric')}${pageNumber}`;
    }
}
